export interface GiftNote {
    title: string;
    /** 항목 안 줄바꿈은 \n, 매장명은 {storeName} 으로 표기한다. */
    items: string[];
}

export const GIFT_EXCHANGE_NOTE: GiftNote = {
    title: '교환권 이용안내',
    items: [
        '본 교환권은 동일 가격의 타 상품으로 교환 가능하며, 초과 금액은 추가 지불하여야 합니다.',
        '본 상품은 매장 내에서 현금으로 환불이 불가 합니다.',
        '본 쿠폰에 대한 제휴할인 및 포인트적립은 브랜드사 정책에 따릅니다.',
        '{storeName} 내 키오스크에 [쿠폰]->[교환권]에서 쿠폰번호 수기입력 및 바코드 리더기로 사용 가능합니다.',
        '제품 교환 시 사용처(가맹점 등)에서 현금영수증 발급이 가능합니다.',
    ],
};

export const GIFT_USAGE_NOTE: GiftNote = {
    title: '유의사항',
    items: [
        '선물하기 교환권은 {storeName} 매장에서만 사용 가능합니다.',
        '동일 가격의 타 상품으로 교환 가능하며, 금액 초과 시 추가 금액 지불 후 이용하실 수 있습니다.',
        '매장 내 현금 환불은 불가합니다.',
        '해당 교환권 사용 시 스탬프 적립은 불가합니다.',
        '매장 이용 시: 매장 내 키오스크 [쿠폰] 메뉴에서 바코드 스캔 또는 쿠폰번호 수기 입력 후 사용 가능합니다.',
        '앱 이용 시: {storeName} 앱 [선물하기] -> [선물등록]에서 바코드 등록 후 사용 가능합니다.',
        '유효기간은 93일 단위로 연장 가능하며, 최초 유효기간 만료 후 환불 신청 시 결제 금액의 90%가 환불됩니다.',
        '유효기간 연장 및 환불은 최초 발행일로부터 최대 5년까지 가능하며, 고객센터를 통해 신청하실 수 있습니다.',
    ],
};

export const ENCOFFEE_GIFT_EXCHANGE_NOTE: GiftNote = {
    title: '교환권 유의사항',
    items: [
        '전국 엔커피 매장에서 사용 가능합니다. (일부 매장 제외)',
        '상기 이미지는 연출된 것으로 실제와 다를 수 있습니다.',
        '결제 시 모바일 쿠폰을 제시해 주시면 됩니다.',
        '타 쿠폰 중복 사용, 추가 할인, 스탬프 적립 가능 여부는 브랜드사 정책을 따릅니다.',
        '본 교환권은 타 제조음료로 교환 가능하며, 차액 발생 시 추가 금액을 지불해야 합니다.',
        '현금으로 교환이 불가합니다.',
        '본 쿠폰 사용 시 현금영수증 발행이 가능합니다.',
    ],
};

export const ENCOFFEE_GIFT_BALANCE_NOTE: GiftNote = {
    title: '금액권 유의사항',
    items: [
        '전국 엔커피 매장에서 사용 가능합니다. (일부 매장 제외)',
        '결제 시 모바일 쿠폰을 제시해 주시면 됩니다.',
        '타 쿠폰 중복 사용, 추가 할인, 스탬프 적립 가능 여부는 브랜드사 정책을 따릅니다.',
        '현금으로 교환이 불가합니다.',
        '본 쿠폰 사용 시 현금영수증 발행이 가능합니다.',
        '잔액은 유효기간 내에 재사용 가능하며, 잔액 환불은 구매처 고객센터로 문의해주시기 바랍니다.\n* 1만원 이하: 80% 이상 사용 시 잔액 환불 가능\n* 1만원 초과: 60% 이상 사용 시 잔액 환불 가능\n* 단, B2B 상품의 경우 환불 불가',
    ],
};

/** 상품(PRODUCT) 단에서 교환권/금액권 구분이 불가해 둘 다 노출 */
export const ENCOFFEE_GIFT_NOTES: GiftNote[] = [ENCOFFEE_GIFT_EXCHANGE_NOTE, ENCOFFEE_GIFT_BALANCE_NOTE];
